import { useState } from "react";

interface DataConfig {
  limit?: string;
  page?: string;
  asc?: string;
  sort?: string;
  [key: string]: string | undefined;
}
function useDefaultDataConfig(
  additionalConfig: { [key: string]: string | undefined } = {},
): {
  dataConfig: DataConfig;
  setDataConfig: React.Dispatch<React.SetStateAction<DataConfig>>;
} {
  const [dataConfig, setDataConfig] = useState<DataConfig>({
    limit: "10",
    page: "0",
    asc: "false",
    sort: "createdDate",
    ...additionalConfig,
  });

  return { dataConfig, setDataConfig };
}

export type { DataConfig };
export { useDefaultDataConfig };
